'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertEnumToKeyValueList = convertEnumToKeyValueList;
exports.getEnumPropName = getEnumPropName;
var removeEvents = function removeEvents() {
  $('.person-image img').unbind('dragstart');
  $('.dashboard-sidenav > ul > li a').unbind('click');
  $('.dashboard-sidenav').unbind('mouseleave');
  $('.dealership > a').unbind('click');
};

var initJqElems = function initJqElems() {
  removeEvents();

  $('.person-image img').on('dragstart', function (event) {
    event.preventDefault();
    $(this).closest('.person-image').trigger('click');
  });

  window.setTimeout(function () {
    $('.dashboard-sidenav > ul > li a').click(function () {
      $(this).closest('.dashboard-sidenav').find('ul.active').removeClass('active');
      $(this).next('ul').addClass('active');
    });
  }, 1);

  $('.dashboard-sidenav').mouseleave(function () {
    $('.dashboard-sidenav ul.active').removeClass('active');
  });

  $('.dealership > a').click(function () {
    $(this).next('.dealership-menu').toggleClass('active');

    $(this).next().find('a').click(function () {
      $(this).parent().parent().removeClass('active');
    });
  });

  $(function () {
    $(window).resize(function () {
      $('.dashboard-main-area').css('min-height', $(window).outerHeight() - $('.dashboard-header').outerHeight(true));
    }).trigger('resize');
  });
};

function convertEnumToKeyValueList(enumObj, defaultOption) {
  var objList = [];

  if (defaultOption) {
    objList.push({
      id: null,
      name: 'Please Select'
    });
  }

  for (var prop in enumObj) {
    objList.push({
      id: enumObj[prop],
      name: prop
    });
  }

  return objList;
}

function getEnumPropName(enumObj, value) {
  for (var prop in enumObj) {
    if (enumObj[prop] === value) {
      return prop;
    }
  }
  return null;
}

exports.initJqElems = initJqElems;


// WEBPACK FOOTER //
// ./client/app/app.misc.js